import type { Content, GaugeId } from '@neopolis/engine';

import { T } from '../textes-interface.js';
import { Jauge } from './Jauge.js';

/** La barre d'état de la ville, visible en permanence pendant la partie. */
export function BarreJauges({
  content,
  gauges,
}: {
  content: Content;
  gauges: Readonly<Record<GaugeId, number>>;
}) {
  return (
    <section aria-label={T.jauges.titre} className="bg-slate-100/80 px-3 py-2 backdrop-blur">
      <ul className="mx-auto flex max-w-5xl flex-wrap gap-2">
        {content.jauges.map((jauge) => (
          <Jauge key={jauge.id} jauge={jauge} valeur={gauges[jauge.id]} />
        ))}
      </ul>
    </section>
  );
}
